var _path, _path2, _rect, _path3, _rect2, _path4, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PwC_Pictogram_Checklist_Black_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0V144H144V0ZM137.86,137.86H6.14V6.14H137.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.57,53.69A11.38,11.38,0,1,0,21.18,42.31,11.39,11.39,0,0,0,32.57,53.69Zm0-16.63a5.25,5.25,0,1,1-5.26,5.25A5.26,5.26,0,0,1,32.57,37.06Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.2,
    y: 39.24,
    width: 69.32,
    height: 6.13
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.57,89.46A11.38,11.38,0,1,0,21.18,78.08,11.39,11.39,0,0,0,32.57,89.46Zm0-16.63a5.25,5.25,0,1,1-5.26,5.25A5.26,5.26,0,0,1,32.57,72.83Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.2,
    y: 75.01,
    width: 69.32,
    height: 6.13
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.57,125.23a11.39,11.39,0,1,0-11.39-11.38A11.4,11.4,0,0,0,32.57,125.23Zm0-16.64a5.26,5.26,0,1,1-5.26,5.26A5.26,5.26,0,0,1,32.57,108.59Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.2,
    y: 110.78,
    width: 69.32,
    height: 6.13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/Checklist.d3700b2f7016e218d400eaee6b127425.svg";
export { ForwardRef as ReactComponent };